import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/settings/',
)({
  validateSearch: z.object({
    person_uuid: z.string().optional().catch(undefined),
  }),
});
